import React, { useState, useCallback } from "react";
import "./faqs.css";

import { Collapse } from "react-collapse";

function Faqs() {
  const [collapse, setCollapse] = useState(false);

  const onClick = useCallback(() => setCollapse(!collapse), [collapse]);

  const faqs = [
    {
      collapse: true,
      title: "What is MonkeyDoo?",
      answer:
        "MonkeyDoo is an NFT collection consisting of 3,000 NFT's. Each MonkeyDoo is unique, but each having a difference rarity score. This rarity score defines the price of the MonkeyDoo on the marketplace.",
    },
    {
      collapse: false,
      title: "How much does a MonkeyDoo cost?",
      answer:
        "Minting a MonkeyDoo NFT costs 1 ETC + gas fees. The gas fees on the Ethereum Classic blockchain are lower than 1 dollar cent.",
    },
    {
      collapse: false,
      title: "How do I purchase a MonkeyDoo?",
      answer:
        "In order to mint a MonkeyDoo NFT, you need to install and use MetaMask. You can mint the NFT from our website.",
    },
    // {
    //   collapse: false,
    //   title: "",
    //   answer:
    //     "You need to add the Ethereum Classic network to your MetaMask. Please follow these steps: click here!",
    // },
  ];
  return (
    <section
      className="container faqs_container"
      id="help"
      style={{
        padding: "10px",
      }}
    >
      <h2>Help / FAQ</h2>

      {faqs.map((faq, i) => (
        <div key={i}>
          <div className="faq_item">
            <div className="faq_item-head">
              <h3>{faq.title}</h3>
              <div className="config">
                <div type="button"></div>
              </div>
            </div>
            <div className="collapse_wrap">
              <div className="collapse_div"> {faq.answer}</div>
            </div>
            {/* </Collapse> */}
          </div>
        </div>
      ))}
      <div>
        <div className="faq_item">
          <div className="faq_item-head">
            <h3
              // style={{
              //   fontSize: "16px",
              // }}
              className="faq-monkey"
            >
              How do I use MetaMask?
            </h3>
            <div className="config">
              <div
                //aria-controls={accessibilityIds.button}
                aria-expanded={true}
                onClick={() => setCollapse(!false, console.log(false))}
                type="button"
              ></div>
            </div>
          </div>
          {/* <Collapse isOpened={collapse}> */}
          <div className="collapse_wrap">
            <div className="collapse_div">
              "You need to add the Ethereum Classic network to your MetaMask.
              Please follow these steps:
              <a
                href="https://www.youtube.com/watch?v=lSzah28w14c"
                target="_blank"
              >
                Click here!
              </a>
            </div>
          </div>
          {/* </Collapse> */}
        </div>
      </div>
      <div>
        <div className="faq_item">
          <div className="faq_item-head">
            <h3
              // style={{
              //   fontSize: "16px",
              // }}
              className="faq-monkey"
            >
              How do I add my MonkeyDoo to my MetaMask?
            </h3>
            <div className="config">
              <div
                //aria-controls={accessibilityIds.button}
                aria-expanded={true}
                // onClick={() => setCollapse(!false, console.log(false))}
                type="button"
              ></div>
            </div>
          </div>
          {/* <Collapse isOpened={collapse}> */}
          <div className="collapse_wrap">
            <div className="collapse_div">
              Please watch these steps in this video!
              <a
                href="https://www.youtube.com/watch?v=lSzah28w14c"
                target="_blank"
              >
                https://www.youtube.com/watch?v=lSzah28w14c
              </a>
            </div>
          </div>
          {/* </Collapse> */}
        </div>
      </div>
    </section>
  );
}

export default Faqs;
